<template>
  <div @click="onClose" class="modal_wrap">
    <div class="modal_container wrapper_body card">
      <div class="card-header position-relative">
        <h5>Отправка сообщения <strong>{{
            type === 'supervisor' ? 'Контролер' : (type === 'manager' ? 'Менеджеру' : 'Курьеру')
          }}</strong></h5>
        <i @click="onClose(null, true)" class="icon-fa icon-fa-close position-absolute close_btn"></i>
      </div>
      <div class="card-body">

        <template>
          <div class="row">
            <div class="col-md-6">
              <template v-if="type !== 'manager'">
                <p class="mb-0">Шаблоны сообщений</p>
                <button @click="extra_message = templates[type][index]" class="btn btn-default mb-1"
                        v-for="(template, index) in templates[type]" type="button">
                  {{ template }}
                </button>
              </template>
              <template v-if="+data.status === 2">
                <p>Курьер: <strong>{{ data.courier?.name ?? 'Не найден получатель' }}</strong></p>
              </template>
            </div>
            <div class="col-md-6">
              <div class="alert alert-info" v-if="type !== 'supervisor'">
                <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
                <template v-if="!loading && receivers">
                  <h6>Получатели:</h6>
                  <div class="receiver" v-for="r in receivers">
                    <p>({{ r.id }}) {{ r.name }}</p>
                    <p class="text-muted" v-for="role in r.roles">{{ role.name_title }}</p>
                  </div>
                  <div class="form-group mt-1" v-if="data.status === 2">
                    <label>
                      <input type="checkbox" v-model="toChiefRunner"> Отправить старшему курьеру
                    </label>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div v-if="$can('runner/orders/calls/details')" class="mb-1">
            <label for="">Информация по клиенту</label>
            <div class="row client_info_block flex-nowrap">
              <div class="col-md-4">
                <div class="message_div">
                  <pulse-loader :loading="orderDetailsLoading" :color="$constants.LOADING_COLOR" class="text-center"/>
                  <template v-if="!orderDetailsLoading">
                    <template v-if="(orderDetails.phoneCalls ?? []).length">
                      <p>Всего звонков: <strong>{{ orderDetails.phoneCalls.length }}</strong></p>
                      <button @click="showPhoneCalls = !showPhoneCalls" v-if="!showPhoneCalls"
                              class="btn btn-xs btn-outline-info">Показать звонки
                      </button>
                      <div v-if="showPhoneCalls" class="mb-1">
                        <div v-for="call in orderDetails.phoneCalls">
                          <p class="fs-12">{{ printDate(call.created_at, 'DD.MM.YYYY HH:mm') }}</p>
                          <audio controls v-if="call.file_link">
                            <source
                              :src="`/api/noa/mangoRecord/${call.id}`"
                              type="audio/mpeg"
                            />
                            Your browser does not support the audio tag.
                          </audio>
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <p>Нет звонков в системе по этому номеру</p>
                    </template>
                  </template>
                </div>
              </div>
              <div class="col-md-8">
                <div class="message_div">
                  <pulse-loader :loading="orderDetailsLoading" :color="$constants.LOADING_COLOR" class="text-center"/>
                  <template v-if="!orderDetailsLoading">
                    <template v-if="(orderDetails.history_orders ?? []).length">
                      <div class="flex justify-content-between mb-1 flex_gap_10 border-bottom"
                           v-for="o in orderDetails.history_orders">
                        <div class="flex-grow-1 fs-12 align-self-center">
                          <p v-for="d in o.details">{{ d.drug.title }}</p>
                        </div>
                        <div class="align-self-center">
                          <OrderStatus :status="o.status"/>
                          <p class="fs-12 text-muted" v-if="o.reject_comment">{{ o.reject_comment }}</p>
                        </div>
                        <div class="align-self-center">
                          <span class="fs-12">{{ printDate(o.created_at, 'DD.MM.YYYY') }}</span>
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      Заявок по этому номеру телефона не найдены
                    </template>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div>
            <p class="mb-0">Текст сообщения:</p>
            <div class="message_div">
              <div v-html="message"/>
              <RunnerSalaryRate :rate="data?.extra_options?.salary_rate ?? 0"/>
            </div>
            <textarea placeholder="Текст сообщение или вопрос" v-model="extra_message" class="form-control" rows="5"/>
          </div>
        </template>
      </div>
      <div class="card-footer text-right">
        <LoadingButton
          title="Отправить"
          className="btn btn-success btn-xs mb-1"
          :onClick="sendMessage"
          :loading="btnLoading"
          color="white"
        />
      </div>
    </div>
  </div>
</template>

<script>

import LoadingButton from '@/components/buttons/LoadingButton'
import api from '@/api'
import moment from 'moment'
import OrderStatus from "@/components/orders/ordersData/OrderStatus.vue";
import RunnerSalaryRate from "@/views/orders/RunnerSalaryRate.vue";

export default {
  props: ['onModalClose', 'data', 'user', 'type'],
  components: {
    RunnerSalaryRate,
    OrderStatus,
    LoadingButton,
  },
  data() {
    return {
      templates: {
        runner: [
          'Позвоните заказчику, для согласования встречи',
          'Звонил клиент, просил обратить внимание на его доставку в первую очередь, как только начнете звонить клиентам!',
          'Клиент просит сбросить фото препарата',
          'Клиент просит сообщить срок годности упаковок',
        ],
        supervisor: [
          'Сменить количество препаратов',
        ]
      },
      toChiefRunner: false,
      btnLoading: false,
      loading: false,
      message: null,
      receivers: null,
      extra_message: null,
      orderDetailsLoading: false,
      orderDetails: {},
      showPhoneCalls: false,
      sendOpt: {
        user: true,
        group: false,
      },
    }
  },
  computed: {
    $AllCities() {
      let cities = this.$store.getters['platform/cities']
      cities[0] = {id: 0, name: 'Почта', short_name: 'Почта'}
      return cities
    },
    $AllProjects() {
      const stores = this.$store.getters['platform/projects'].filter(
        s => s.id && s.id !== 4
      )
      const sortedStores = stores.reduce((acc, s) => {
        acc[s.id] = {...s}
        return acc
      }, {})
      return sortedStores
    }
  },
  mounted() {
    const body = document.getElementsByTagName('body')[0]
    body.style.overflow = 'hidden'
    this.generateTextMessage();
    if (this.type !== 'supervisor') {
      this.getReceivers();
    }
    if (this.$can('runner/orders/calls/details')) {
      this.getOrderInfo();
    }
  },
  methods: {
    async getOrderInfo() {
      this.orderDetailsLoading = true;
      const {data} = await api.index('/new/orders/details/' + this.data.id);
      if (data.success) {
        this.orderDetails = data;
      }
      this.orderDetailsLoading = false;
    },
    async getReceivers() {
      this.loading = true;
      const {data} = await api.index('/new/orders/getNoticeReceivers/' + this.data.id);
      if (data.success) {
        this.receivers = data.records;
      } else {
        toastr['warning'](data.message || 'Ошибка сервера')
      }
      this.loading = false;
    },
    async sendMessage() {
      if (this.btnLoading) return
      if (!this.extra_message) {
        toastr['warning']('Добавьте сообщение')
        return;
      }
      if (!Object.values(this.sendOpt).find((o) => o)) return
      this.btnLoading = true

      let type = '';
      switch (this.type) {
        case 'supervisor':
          type = 'order_correction_to_super_from_manager'
          break;
        case 'manager':
          type = 'order_message_runner_to_manager'
          break;
        default:
          type = 'order_info_to_runner_from_manager'
          break;
      }

      const {data} = await api.post('/tasks/new', {
        // type: this.type === 'supervisor' ? 'order_correction_to_super_from_manager' : 'order_info_to_runner_from_manager',
        // type: this.type === 'supervisor' ? 'order_message_runner_to_manager' : 'order_info_to_runner_from_manager',
        type,
        order_id: this.data.id,
        message: this.extra_message,
        to_users: (this.receivers || []).map((r) => r.id),
        toChiefRunner: this.toChiefRunner,
        // type: this.type === 'supervisor' ? 2 : 3
      })

      if (data.success) {
        toastr['success'](data.message || 'Отправлено')
        setTimeout(() => {
          this.onClose(null, true)
        }, 300)
      } else {
        toastr['warning'](data.message || 'Ошибка сервера')
      }
      this.btnLoading = false
    },
    generateTextMessage() {
      if (this.type === 'supervisor') {
        // this.message = `Заявка: <b><a href="https://admin.rancond.info/orders/edit/${this.data.id}">${this.data.id}</a></b><br>`
        this.message = `Заявка: <b>${this.data.id}</b><br>`
      } else {
        this.message = `Заявка: <b>${this.data.id}</b><br>`
      }
      this.message += `Клиент: <b>${this.data.client_name || 'не указано имя'}</b><br>Телефоны:<br>`
      // this.data.phones.forEach((p) => {
      //   this.message += `<a href="tel:${p.full_phone}">+${p.full_phone.substring(2)}</a><br>`
      //   if (p.comment) {
      //     this.message += `<strong>${p.comment}</strong><br>`
      //   }
      // })
      let sum = 0
      this.message += `${this.$AllProjects[this.data.site_id]?.name} (${this.data.city_id ? this.$AllCities[this.data.city_id]?.name : this.data.city_name})<br>`
      this.data.details.forEach((d) => {
        this.message += `${d.new_drug.title} * ${d.qty} * <b>${d.price}</b><br>`
        sum += (d.qty * d.price)
      })
      if (this.data.discount) {
        this.message += `Скидка: <b>${this.data.discount} ${this.data.discount_type ? '%' : ''}</b><br>`
      }
      this.message += `Доставка: <b>${this.data.delivery_price || 0}</b><br>`
      this.message += `Итого: <b>${this.data.price}</b><br>`
      this.message += `Дата доставки: <strong>${moment(this.data.delivery_date).format('DD.MM.YYYY')}</strong><br>`
      if (this.data.courier_name) {
        this.message += `Курьер: <strong>${this.data.courier_name}</strong><br>`
      }
      this.message += `Адрес: <strong>${this.data.address}</strong><br>`
      if (this.data.report_date) {
        this.message += `Дата отчета: <strong>${moment(this.data.report_date).format('DD.MM.YYYY')}</strong><br>`
      }
      // this.extra_message = this.templates[this.type][0];
    },
    onClose(e, global = false) {
      if (global || e && e.target && e.target.className.includes('modal_wrap')) {
        const body = document.getElementsByTagName('body')[0]
        body.style.overflow = 'auto'
        this.onModalClose()
      }
    }
  }
}

</script>

<style scoped>
.receiver {
  border: 1px solid lightgray;
  margin-bottom: 3px;
  padding: 5px;
}

.message_div p {
  margin-bottom: 2px;
}

.client_info_block {
  max-height: 160px;
  overflow: hidden;
}

.client_info_block .message_div {
  height: 100%;
}

.message_div {
  padding: 10px;
  font-size: 16px;
  border: 1px solid lightgray;
  margin-bottom: 10px;
  overflow: hidden;
  overflow-y: auto;
}

.modal_wrap {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: fixed;
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 9999;
  transition: all 0.3s ease 0s;
  background-color: rgba(0, 0, 0, 0.5);
}

.wrapper_body {
  position: relative;
  transition: all 0.3s ease 0s;
  background-color: white;
  width: 75%;
  top: 10%;
  margin: 0 auto;
  height: 80%;
  z-index: 9999;
}

.close_btn {
  top: 11px;
  font-size: 24px;
  right: 3px;
  cursor: pointer;
}

.close_btn:hover {
  color: #5BBFDE;
}

.card-body {
  overflow: auto;
}

audio {
  height: 24px;
}

.text_block {
  max-height: 315px;
}

i {
  /*  cursor: pointer;*/
  /*  color: #5BBFDE;*/
}
</style>
